import styled, { ThemeProvider } from 'styled-components';
import React, { ComponentType } from 'react';
import color from 'color';
import forEach from 'lodash/forEach';

const theme = {
  screen: 'sm',
  color: {
    primary: '#7555F7',
    // second:'#6C6FFF',
    secondary: '#999',
    default: '#292929',
    darkest: '#000',
    darker: '#2b2b2b',
    dark: '#373a3c',
    gray: '#55595c',
    grayLight: '#999',
    grayLighter: '#e7e7e7',
    grayLightest: '#f7f7f9',
    warn: '#f00',
    success: '#4caf50',
    second: '#40A3FF',
    info: '#ffcd00',
    mask: 'rgba(0,0,0,.5)',
    bar: 'rgba(255,255,255,.2)',
    white: '#fff',
    black: '#000',
  },
  colorGradient: {
    primary: 'linear-gradient(90deg, #C669FF 0%, #7555F7 100%)',
    warn: 'linear-gradient(270deg, #FF5D7E 0%, #FF504D 100%);',
  },
  colorHover: {},
  size: 40,
};

forEach(theme.color, (val, key) => {
  theme.colorHover[key] = color(val).darken(0.1).hex();
});

// console.log('theme====>',theme)

// type ThemeInterface = typeof theme;

// declare module 'styled-components' {
//   export interface DefaultTheme extends ThemeInterface {}
// }

// const WithTheme = ({children}: any) => {
//   return <ThemeProvider theme={ theme }>{ children }</ThemeProvider>
// }

// const screen = (opts) => (props) => opts[props.theme.screen];

// export { WithTheme };

export default theme;
